<div *ngIf="sliderImages.length > 0" class="d-flex flex-wrap flex-row gap-2">
  <img
    *ngFor="let image of sliderImages; let i = index"
    [alt]="image.caption"
    [src]="image.thumb"
    (click)="openImage(i)"
    height="150"
  />
</div>
